import React, { useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { SortIcon, DropdownDots } from "../../../components/ui/icons";
import DeleteAlertusTokenModal from "../../../components/deleteAlertusTokenModal";

const AlertusColumns = () => {
  return [
      {
        accessorFn: (row) => `${row.name}`,
        accessorKey: "name",
        header: () => (
          <div className="table-heading">
            Token Name
            <span><SortIcon /></span>
          </div>
        ),
        cell: (row) => <div className="table-cell">{row.getValue()}</div>,
        width: 200,        
        enableColumnFilter: false,    
      },
      {
        accessorFn: (row) => `${row.createAt}`,
        accessorKey: "Created At",
        header: () => (
          <div className="table-heading">
            Issued At
            <span><SortIcon /></span>
          </div>
        ),
        cell: (row) => <div className="table-cell">{row.getValue()}</div>,
        width: 300,
        enableColumnFilter: false,
      },
      {
        accessorFn: (row) => `${row.endAt}`,
        accessorKey: "Ended At",
        header: () => (
          <div className="table-heading">
            Expires At
            <span><SortIcon /></span>
          </div>
        ),
        cell: (row) => <div className="table-cell">{row.getValue()}</div>,
        width: 300,
        enableColumnFilter: false,
      },
      {
        accessorKey: "actions",
        header: () => <span></span>,
        cell: (row) => (
          <div className="actions-btns">
            <Dropdown>
              <Dropdown.Toggle id="dropdowndots">
                <DropdownDots />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>
                  <DeleteAlertusTokenModal 
                    id={row.row.original.id} 
                    name={row.row.original.name} 
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ),
        maxSize: 80,
        enableColumnFilter: false,
      },
    ]
};

export default AlertusColumns;
